/* A mutation list for collaborators */
export const SET_UNREAD_MESSAGE_INFO = 'SET_UNREAD_MESSAGE_INFO';
export const SET_USER_AND_HOTEL_INFO = 'SET_USER_AND_HOTEL_INFO';
export const SET_ORG_TREE = 'SET_ORG_TREE';
export const GET_CRM_UPDATE_CLOSE = 'GET_CRM_UPDATE_CLOSE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js